import { Component, OnInit, ViewChild } from '@angular/core';
import { interval } from 'rxjs';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import beautify from 'xml-beautifier';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-fx-proccess-log',
  templateUrl: './fx-proccess-log.component.html',
  styleUrls: ['./fx-proccess-log.component.css'],
   providers: [
        {
          provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
    
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
      ]
})
export class FxProccessLogComponent implements OnInit {

 today = new Date();
    today1 = new Date();
    Val: string;
    hotellistproperty: any = []
    lstBooking: any = [];
    // public client: Client;
    idsProductList: idsProductList[] = [];
    dataSource: MatTableDataSource<idsProductList>;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    displayedColumns = ['exeStatus', 'token','recordType','cdt','FXRequest','CHRequest','CHResponse','FXStatusRequest','FXStatusResponse'];//'Hotel',
    apiresult: any;
    Pmscodevalue: any;
    PropertyName:any;
    errorMsgSubscription: boolean;
    errorMessage: string;
    displayContent: boolean;
    selectedDateStore: any;
    selectedTOODateStore: any;
    filterProperty: any;
    blinkOfflineHotel: boolean;
    currentDateStore: any;
    storeHeartBeatValue: any;
    XMLName: any;
    defaultData: any;
      pageSize = 50;
    status: void;
        PGF: any = "0";
      PGT: any = "50";
       searchValueData: any;
    constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, 
      private datePipe: DatePipe) { 
      }
display: Boolean = false;
  public User: string;
  selectedDate: any = new Date(this.today.setDate(this.today.getDate()));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate()));
  lastThirthydays: any = new Date(this.today.setDate(this.today.getDate() - 30));
  afterThirthydays: any = new Date(this.today.setDate(this.today.getDate() + 30));
  isProgressing: Boolean = false;
  lstGetCMHotelsProperty: any = [];
  storePmsCode: string
  Userid: any = [];
  selectedProperty: any;
  isIDSUser: boolean;
  search: string;
  totalcount: any = 0;
  statusResult: string;
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  checkTodayDate:any
  CurrentDate = new Date();
  searchBarFilter: boolean = false;
   productCode: string[];
  hideSearchFilter(){
    this.Val = '';
    this.searchBarFilter = false
  }
  ngOnInit() {
    this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    this.isProgressing = true;
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.errorMsgSubscription = true
    this.statusResult = "not sent"
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }
callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getfxproperties()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          /* this.apiresult.unshift({
            "propertyCode": "All",
            "propertyName": "All Property"
          }); */

          this.dropdownDeptData = this.apiresult
          // if (this.SourceBy == 'Report') {
          this.selectedDeptItems = this.getDimensionsByFilter("All");
          console.log('this.StoreValuetest', this.selectedDeptItems[0].propertyCode);
          this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
          this.PropertyName=this.apiresult[0].propertyName
          console.log('this.Pmscodevalue =', this.Pmscodevalue)
            console.log('this.PropertyName =', this.PropertyName)
          // }
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });
  }
  getDimensionsByFilter(propertyCode: any) {
  return this.dropdownDeptData.filter(
    (x: { propertyCode: any }) => String(x.propertyCode) === String(propertyCode)
  );
}
changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
      this.Val = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        this.PropertyName=this.selectedDeptItems[0].propertyName
        console.log('pms code value = ', this.Pmscodevalue)
        console.log('pms name value = ', this.PropertyName)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }
 
GetCommonMethodForLog() {
 /*  ValSearchDownload:any
          console.log('ValSearchDownload = ',ValSearchDownload)
          this.searchValueData = ValSearchDownload */
          this.PGF = "0";
          this.PGT = "50";
          this.GetLoadMethodIDSUser()
      
        }
        GetLoadMethodIDSUser() {
    this.searchBarFilter = true
    this.isProgressing = true;
    this.selectedDateStore = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODateStore = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    console.log('selectedProperty Result = ', this.Pmscodevalue)
    console.log('selectedDate Result = ', this.selectedDateStore)
    console.log('selectedTOODate Result = ', this.selectedTOODateStore)
    console.log('Status Result = ', this.statusResult)
    let propertyCode = (this.Pmscodevalue === 'All' || this.Pmscodevalue === 0) ? 'ALL' : this.Pmscodevalue;
    //this.productCode=this.PropertyName.split('-')[2]
    let parts = this.PropertyName.split(' - ');
    
    this.productCode = parts[parts.length - 1]; // "HUBOS"
    //console.log('hubosValue',hubosValue);

    console.log("Final PropertyName sent to API",this.productCode);
  console.log('Final propertyCode sent to API:', propertyCode);
          console.log("propertyname",this.PropertyName)
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    } else {
      this.apiCallIdsService.readfxpropertieslog(propertyCode,this.productCode, this.selectedDateStore, this.selectedTOODateStore, this.statusResult,this.searchValueData,this.PGF, this.PGT,)
        .subscribe((data) => {
          console.log('response =', data);
          if (data.length < 1) {
            this.totalcount=data.length;
            console.log("totalcount",this.totalcount)
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          else {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
    }

  }
Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { propertyCode: { toString: () => string; }; propertyName: { toString: () => string; } }) => {
      return res.propertyCode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.propertyName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
    }
  }
   closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
  pageEvent(e:any) {
          console.log('pageEvent = ', e)
          var pageIndex = e.pageIndex;
          pageIndex = pageIndex;
          console.log('pageIndex = ', pageIndex)
          this.pageSize = e.pageSize
          console.log('pageSize = ', this.pageSize)
          this.PGF = this.pageSize * pageIndex + 1;
          this.PGT = this.PGF + e.pageSize - 1;
          console.log("this.PGF", this.PGF)
          console.log("this.PGT", this.PGT)
          this.GetLoadMethodIDSUser();
        }
getHubCode(propertyName: string): string {
  if (!propertyName) return '';

  let afterSemicolon = propertyName.includes(';') 
    ? propertyName.split(';').pop() 
    : propertyName;

  let parts = afterSemicolon.split('-');
  return parts[parts.length - 1].trim(); // returns HUBOS
}
getDynamicProductCode(element: any): string {
  if (!element || !element.propertyName) return '';
 let parts = this.PropertyName.split(' - ');
     console.log("parts",parts[parts.length - 1]); 
    return parts[parts.length - 1]; // "HUBOS"
 /*  let afterSemicolon = element.propertyName.includes(';') 
    ? element.propertyName.split(';').pop() 
    : element.propertyName;
console.log("aftersemicolonvalue",afterSemicolon);
  let parts = afterSemicolon.split('-');
   console.log("parts",parts[parts.length - 1]); */
  //return parts[parts.length - 1].trim();
 
}




      showXml(id:any,productCode:any, xmltype: any) {

      this.status = this.LoadXML(id,productCode, xmltype);
  }
  LoadXML(id, productCode:any, xmltype: any) {
    this.isProgressing = true;
    console.log('id', id);
       console.log('xmltproductCodeype', productCode);
    console.log('xmltype', xmltype);
  
    //  You’re passing the class name instead of the variable. Use id.
    this.apiCallIdsService.readfxPropertiesJson(id,productCode, xmltype)
      .subscribe({
        next: (data) => {
          if (!data || data.length < 1 || !data[0].jsonData) {
            this.toastr.error('No valid data to load');
            this.isProgressing = false;
            return;
          }
  
          try {
            const xml = beautify(data[0].jsonData);
            console.log(xml);
            this.XMLName = xmltype === 'FXREQ' ? 'FX Request JSON' :xmltype==='CHREQ'?'CH Request JSON'
                    :xmltype==='CHRES'?'CH Response JSON':xmltype==='FXSTATUSREQ'?'FX Status Request JSON' :  ' FX Status Response JSON';
           
            this.defaultData = xml;
            this.display = true;
          } catch (err) {
            console.error('Beautify error:', err);
            this.toastr.error('Invalid XML/JSON content');
          } finally {
            this.isProgressing = false;
          }
        },
        error: () => {
          this.toastr.error('Failed to load request!');
          this.isProgressing = false;
        }
      });
  }

}
